module.exports = __webpack_public_path__ + "img/0Q3A6078_L_WoodMatted_MockedUp.ad7ac235.jpg";